import { useReducer, useEffect } from "react";
import logDownloadReducer, { initialState } from "./reducer";
import { logDownload } from "./api";
import ACTIONS from "./actions";

async function logDownloadDetails(dispatch, chargerId, fileName) {
  dispatch({ type: ACTIONS.FETCH_LOG_DOWNLOAD_INIT });
  try {
    const logDownloadDetails = await logDownload(chargerId, fileName);
    if (logDownloadDetails) {
      dispatch({ type: ACTIONS.FETCH_LOG_DOWNLOAD_SUCCESS, payload: logDownloadDetails?.data });
    } else {
      dispatch({ type: ACTIONS.FETCH_LOG_DOWNLOAD_FAILURE });
    }
  } catch (error) {
    dispatch({ type: ACTIONS.FETCH_LOG_DOWNLOAD_FAILURE });
  }
}

function useLogDownloadReducer(chargerId, fileName) {
  const [state, dispatch] = useReducer(logDownloadReducer, initialState);

  useEffect(() => {
    if (chargerId && fileName) {
      logDownloadDetails(dispatch, chargerId, fileName);
    }
  }, [chargerId, fileName]);

  // return only the status (step chart) slice to preserve previous hook API
  return {
    state,
  };
}

export default useLogDownloadReducer;
